import { routeItem } from '@/types';
import { lazy } from 'react';
import BlogForm from './pages/BlogForm';
import Blog from './pages/Blog';
import { Outlet } from 'react-router';

const ListingPage = lazy(() => import('./pages/ListingPage'));

export const blogsRoutes: routeItem[] = [
  {
    path: 'blogs',
    element: <Outlet />,
    children: [
      {
        index: true,
        element: <ListingPage />,
      },
      {
        path: 'create',
        element: <BlogForm />,
      },
      {
        path: ':id/edit',
        element: <BlogForm />,
      },
      {
        path: ':id',
        element: <Blog />,
      },
    ]
  },
  
];